import React, { useEffect } from "react";
import HistoryTemplate from "../../Templetes/History/History.template";

const HistoryPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - History";
  }, []);
  return <HistoryTemplate />;
};

export default HistoryPage;
